

var getCurrentBlock = function getCurrentBlock(editorState) {
  var selection = editorState.getSelection();
  return editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
};

export default getCurrentBlock;